import './donor/bootstrap';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import './components/ui/tokens.css';
import './styles.css';
import './donor/donor.css';
import './components/ui/ui.css';
import './donor/church.css';
import './donor/mobile-navigation.css';

const root = document.getElementById('root');

if (root === null) throw new Error('Missing #root element');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
